import { css } from 'aphrodite';
import type { FC } from 'react';

import { styleSheet } from '../../components/TwilioDialer/styles';
import type { CallState } from '../call';

const STATUS_LABELS: Record<CallState['status'], string> = {
	uninit: 'Call audio not enabled',
	idle: 'Listening for incoming calls',
	ended: 'Listening for incoming calls',
	ringing: 'Incoming call',
	dialing: 'Calling…',
	connected: 'On a call',
	practice: 'Practice call',
};

/**
 * The dialer box of the Coffee status banner, for the focused view. The banner's own dialer reads the legacy
 * telephony context, which the focused view does not mount because its call pipeline owns the Twilio device.
 */
export const FocusedDialerStatus: FC<{ callState: CallState }> = ({ callState }) => {
	const dotStyle =
		callState.status === 'uninit' ? styleSheet.dialerStatusDotRegistering : styleSheet.dialerStatusDotRegistered;
	return (
		<div className={css(styleSheet.dialerContainer)}>
			<div className={css(styleSheet.dialerStatus)} role='status'>
				<div className={css(styleSheet.dialerCallInfoText, styleSheet.dialerStatusDot, dotStyle)} />
				<div className={css(styleSheet.dialerCallInfoText)}>{STATUS_LABELS[callState.status]}</div>
			</div>
		</div>
	);
};
